/* global TD, FS, gRootURL */
import $ from "jquery";
import { addCallback } from "./td";
import "./td-location";
import "./td-patinput";
import "./td-signature";
import "./td-markup";
import "./td-selectall";

var activeRequestCount = 0;
var submitWasRequested = false;

var touchEvents = "ontouchstart" in window;

function $$(ctx/*, name, name...*/) {
	var s = [];
	for(var i = 1, a = arguments, l = a.length; i < l; i++)
		s[i - 1] = "[name=\"" + a[i] + "\"]";
	return $(s.join(","), ctx);
}

var html = {
	getValue: function(ctx, name) {
		return $$(ctx, name).val();
	},
	// to set into hidden control
	asString: function(v) {
		return v ? v.toString() : "";
	},
	asParams: function(ctx, name) {
		return $$(ctx, name).serialize();
	},
	setValue: function(ctx, name, value) {
		html.setHTML(ctx, name, value);
	},
	setHTML: function(ctx, name, html) {
		var ctrl = $("#" + name + "_value", ctx);
		ctrl.html(html != null ? html : "");
	}
},
input = $.extend({}, html, {
	setValue: function(ctx, name, val) {
		$$(ctx, name).val(val != null ? val : "");
	}
}),
select = $.extend({}, input, {
	setValue: function(ctx, name, value) {
		value = value || "";
		var c = $$(ctx, name), o = $("option", c);
		var found = false;
		o.each(function(i, e) {
			if(e.value == value)
				return !(e.selected = found = true);
		});
		if(!found) {
			var x = $("<option/>", { value: value }).text(value);
			o.filter(":first").after(x);
			c.val(value); // IE7 does not recognize adding selected <option/>
		}
	}
}),
radio = $.extend({}, input, {
	getValue: function(ctx, name) {
		return $$(ctx, name).filter(":checked").val();
	},
	setValue: function(ctx, name, value) {
		$$(ctx, name).val(value != null ? [value] : []);
	}
}),
check = $.extend({}, radio, {
	setValue: function(ctx, name, value) {
		$$(ctx, name).prop("checked", !!value);
	}
}),
mcheck = $.extend({}, input, {
	getValue: function(ctx, name) {
		var r = [];
		$$(ctx, name).filter(":checked").each(function(i, e) { r[i] = e.value; });
		return r;
	},
	setValue: function(ctx, name, value) {
		$$(ctx, name).val(Array.isArray(value) ? value : [value]);
	}
}),
mtext = $.extend({}, input, {
	setChangeCallback: function(ctx, name, data) {
		setChangeCallback(ctx, name, data, $$(ctx, name + "_o"));
	},
	asParams: function(ctx, name) {
		return $$(ctx, name + "_h", name + "_o", name).serialize();
	},
	getValue: function(ctx, name) {
		var ctrl, value = "";
		ctrl = $$(ctx, name + "_h");
		if(ctrl.length)
			value += ctrl[0].value;
		ctrl = $$(ctx, name + "_o");
		if(ctrl && ctrl[0].value !== "") {
			if(value !== "") value += "\r\n";
			// insert TS for proper ops
			value += ctrl[0].value;
		}
		return value;
	},
	setValue: function(ctx, name, value) {
		var ctrl;
		ctrl = $$(ctx, name + "_h");
		if(ctrl.length) ctrl[0].value = value.h;
		ctrl = $$(ctx, name + "_o");
		if(ctrl.length) ctrl[0].value = value.o;
		$("#" + name).html(value.m);
	}
}),
timestamp = $.extend({}, input, {
	getValue: function(ctx, name) {
		var ctrl = $$(ctx, name);
		var v0 = ctrl[0].value, v1 = ctrl[1].value;
		return v0 !== "" ? [v0, v1] : null;
	},
	asString: function(value) {
		return value ? value.join("|") : "";
	},
	setValue: function(ctx, name, value) {
		var ctrl = $$(ctx, name);
		ctrl.val(function(i) { return value[i]; });
	}
}),
reference = $.extend({}, html, {
	getValue: function(ctx, name) {
		var v = [];
		$$(ctx, name).each(function(i, e) {
			if(e.tagName !== "INPUT" ||
				e.type != "radio" && e.type != "checkbox" ||
				e.checked) {
				v.push($(e).val());
			}
		});
		return v ? v.length == 1 ? v[0] : v : null;
	},
	asParams: function(ctx, name) {
		return $$(ctx, name, name + "_oldkeys", name + "_table", name + "_text", name + "_filter").serialize();
	}
}),
attachment = $.extend({}, html, {
	asParams: function(ctx, name) {
		var file = name + "=" + encodeURIComponent($$(ctx, name).val());
		var rest = $$(ctx, name + "_guid", name + "_delete").serialize();
		if(rest !== "")
			file += "&" + rest;
		return file;
	},
	setHTML: function(ctx, name, htmlText) {
		html.setHTML(ctx, name, htmlText); // call base
		if(htmlText) // force form to send form-data
			ctx.closest("form").attr("enctype", "multipart/form-data");
	}
}),
td = {
	html: html,
	input: input,
	select: select,
	radio: radio,
	check: check,
	mcheck: mcheck,
	mtext: mtext,
	timestamp: timestamp,
	reference: reference,
	attachment: attachment
};

function setChangeCallback(ctx, key, data, elt) {
	function _set(e) {
		e = $(e);
		var evt = "change";
		if(e.is("INPUT")) {
			switch(e.prop("type")) {
				case "checkbox":
				case "radio":
					evt = "click";
					break;
				case "button":
				case "submit":
				case "reset":
				case "hidden":
				case "file":
				case "image":
					break;
				default:
					e.attr("autocomplete", "off");
					break;
			}
		}
		if(!e.data("td-changecallback-set")) {
			e.data("td-changecallback-set", true)
			.on(evt, function() { sendFormData(ctx, key, data); });
		}
	}

	if(arguments.length == 4) {
		if(elt) _set(elt);
	}
	else {
		elt = data.controls[key];
		if(elt && td[elt.e].setChangeCallback) {
			td[elt.e].setChangeCallback(ctx, key, data);
			return;
		}
		elt = $$(ctx, key).each(function(i, e) {
			_set(e);
		});
	}
}

function sendFormData(ctx, key, data, fromDoubleClick) {
	var qs, url = data.url;
	if(url) {
		var n = url.indexOf("?");
		if(n >= 0) {
			qs = $.qstring(url.substring(n));
			url = url.substr(0, n);
		}
		else {
			qs = $.qstring("");
		}
	}
	qs["set"]("cmd", fromDoubleClick ? "dblclk" : "dynrefresh");
	qs["set"]("f", key.substring(2));
	if(data.preview)
		qs["set"]("vc", 1);
	url += "?" + qs.toString();

	var pbody = [];

	function asParams(key) {
		var c = ctls[key];
		c = c.t == 1 || c.t == 2 ? td[c.e] : input;
		var p = c.asParams(ctx, key);
		if(p) pbody.push(p);
	}

	var ctls = data.controls;
	// generate old control state [hidden/visible/readonly/editable]
	for(var x in ctls) {
		pbody.push("OT_" + x + "=" + ctls[x].t);
		var eid = "e_" + x;
		var val = $$(ctx, eid).val();
		if(val != null)
			pbody.push(eid + "=" + val);
	}
	// generate current control's value
	asParams(key);
	// generate dependent controls, if any
	var deps = data.dependencies[key];
	if(deps) {
		deps = deps.controls;
		for(var i = 0; i < deps.length; i++) {
			var k = deps[i];
			asParams(k);
			var xk = "c_" + k;
			var ck = $$(ctx, xk);
			if(ck.length)
				pbody.push(ck.serialize());
		}
	}
	pbody.push("postbackcomplete=1");
	pbody = pbody.join("&");
	$.ajax(url, {
		type: "POST",
		data: pbody,
		dataType: "json",
		beforeSend: function() {
			activeRequestCount++;
		},
		complete: function() {
			if(--activeRequestCount <= 0
				&& submitWasRequested
				&& ctx.is("form")) {
				if(verifyRequired(ctx)) {
					FS.Form.disableButtons(ctx, true);
					submitWasRequested = false;
				}
				else
					ctx[0].submit();
			}
		},
		success: function(r/*, textStatus, jqXHR*/) {
			sendFormDataCallback(ctx, key, data, fromDoubleClick, r);
		},
		timeout: 2 * 60 * 1000 // 2m
	});
}

function sendFormDataCallback(ctx, key, data, fromDoubleClick, r) {

	function setHidden(ctx, data, q, type) {
		if(data.controls[q]) {
			if(!type) type = data.controls[q].t;
			var f = type == 1 || type == 2 ? td[data.controls[q].e] : input;
			// create cf
			var v = f.getValue(ctx, q);
			v = f.asString(v);
			var of = $$(ctx, "o_" + q);
			if(!of.length)
				ctx.prepend(of = $("<input/>", { type: "hidden", name: "o_" + q }));
			of.val(v);
		}
	}

	if(!fromDoubleClick) {
		var cf = $$(ctx, "c_" + key);
		if(!cf.length)
			cf = $("<input/>", { type: "hidden", name: "c_" + key }).prependTo(ctx);
		cf.val("1");
	}
	setHidden(ctx, data, key);

	for(var q in r) {
		if(data.controls[q]) {
			var rq = r[q];
			// 1 - editable, 2 - required, 4 - readonly, 5 - hidden
			var type = rq.type;
			var align = rq.align;
			// manage state
			var label = $("#" + q + "_label");
			label.toggleClass("ui-editable", !!rq.ae);
			if(label.is("td,th")) {
				label.next("td")
					.toggleClass("fs-edit", type == 1 || type == 2)
					.toggleClass("ui-required", type == 2);
				label.nextUntil("th").addBack().toggle(type != 5);
			} else {
				label
					.removeClass("td-ctrl-progress")
					.toggleClass("ui-hidden", type == 5)
					.toggleClass("ui-required", type == 2)
					.toggleClass("ui-invalid", false) // reset any error
					.find(">dd")
					.toggleClass("fs-alignright", align == "right" && (type == 3 || type == 4))
					.toggleClass("fs-edit", type == 1 || type == 2);
				// visible and changed? - animate!
				if(type != 5 && (rq.html !== undefined || rq.value !== undefined)) {
					var oldBG = label.css("backgroundColor"),
						newBG = label.find(">dd").css("backgroundColor");
					label.css("backgroundColor", newBG)
						.animate({ "backgroundColor": oldBG }, 1000);
				}
			}
			var f = type == 1 || type == 2 ? td[data.controls[q].e] : input;
			data.controls[q].t = type;
			if(rq.html !== undefined)
				f.setHTML(ctx, q, rq.html);
			else if(r[q].value !== undefined)
				f.setValue(ctx, q, rq.value);
			if(data.dependencies[q])
				setChangeCallback(ctx, q, data);
		}
		else if(q == "sections" || q == "texts") {
			for(var s in r[q]) {
				var t = r[q][s];
				s = $(q == "sections" ? "#section_" + s : "#" + s + "_label");
				s.toggleClass("ui-hidden", t == "hidden");
				if(q == "sections") {
					var isCollapsed = t == "collapsed";
					var isExpanded = t == "expanded";
					var h = s.find(">header .hdr3");
					if (isCollapsed || isExpanded) {
						h.addClass("ui-sectiontoggle ui-icon-" + (isCollapsed ? "collapsed" : "expanded"));
					} else {
						h.removeClass("ui-icon-expanded ui-icon-collapsed ui-sectiontoggle");
					}
					s.toggleClass("ui-collapsed", isCollapsed);
					s.toggleClass("ui-expanded", isCollapsed);
				}
			}
		}
	}
	for(var qq in r)
		setHidden(ctx, data, qq, r[qq].type);
	initDynControls(ctx);
	verifyRequired(ctx, true);
	if(fromDoubleClick) {
		setFocus($("#" + key + "_label"));
	}
}

const initScripts = [];

function addInitControl(fn) {
	initScripts.push(fn);
}

function initDynControls(ctx) {
	FS.overrideDatePicker();
    $("input.date", ctx).datepicker();
    $("input.td-location-edit", ctx).locationpicker();
	$("input[type=\"file\"]", ctx).filepicker({
		onremove: function() {
			$("input[type=\"hidden\"][name=\"" + this.attr("name") + "_guid\"]", ctx).val("");
		}
	});
	$("input[data-pattern]", ctx).patInput();
	$("input.td-typeinpicker", ctx).each(function(i, e) {
		var focusFlag = "autocomplete.focused";
		var noDataItem = { value: "" };
		var url = $(e).attr("data-autocomplete-url");

		function preventDefault(e) {
			e.preventDefault();
		}

		function val(e, item) {
			var v = $(e.attr("data-autocomplete-value"));
			if(item.label != null) {
				e.val(item.label);
				// previous value to compare to for sending change event is stored on blur
				// when focus does not leave control change is not triggered
				e.data("uiAutocomplete").previous = item.label;
			}
			// since we sometimes reset the value to trigger server search
			// we always notify change when value to set is empty
			if(item.value === "" || v.val() !== item.value) {
				v.val(item.value).trigger("change");
			}
		}
		/*
		Autocomplete delays sending change event.
		As the result, when clicking submit button right from the input control
		the form submitted before we have a chance to resolve typed text.
			
		Native change is triggered before the form is submitted.
		So, let's track when control has the focus and if we did not received
		the change from picker, reset it
		*/
		$(e).on("focus", function(e) {
			$(e.target).data(focusFlag, true);
		}).on("change", function(e) {
			e = $(e.target);
			if(e.data(focusFlag)) {
				$(e.attr("data-autocomplete-value")).val("");
				var t = e.attr("data-autocomplete-text");
				if(t) $(t).val(e.val());
			}
		}).autocomplete({
			minLength: 2,
            classes: { "ui-autocomplete": "td-embedded" },
			source: function(term, callback) {
				return $.getJSON(url, { search: term.term, top: 20, js: Math.random() }, callback);
			},

			// when form submits, we get this a little bit too late
			// in case of multi-table picker there is also native "change" event
			// that resets the value and copies the search term into hidden
			change: function(event, ui) {
				var e = $(event.target), v = $(e.attr("data-autocomplete-value"));
				e.data(focusFlag, false);
				if(ui.item == null) {
					var term = e.val();
					if(term !== "") // something typed?
					{
						v.val(""); // silently reset the value, ask for suggestions
						$.getJSON(url, { search: term, js: Math.random() }, function(d) {
							val(e, Array.isArray(d) && d.length == 1 ? d[0] : noDataItem);
						});
					}
					else // empty box - reset value and notify
					{
						val(e, noDataItem);
					}
				}
			},

			// list selection changes, but not confirmed
			// provide feedback by updating type-in box with the selected label
			focus: function(event, ui) {
				$(event.target).val(ui.item.label);
				return false;
			},

			// list selection changes, and confirmed
			// set both the label and the value, notify changes
			select: function(event, ui) {
				val($(event.target)
					.data(focusFlag, false),
					ui.item);
				return false;
			}
		}).data("uiAutocomplete")._renderItem = function(ul, item) {
			return $("<li>").data("ui-autocomplete-item", item).append(
				$("<a>", { href: "#" }).on("click", preventDefault).text(item.label))
				.appendTo(ul);
		};
	});

	TD.initSignature?.();
	TD.initMarkupToolbars?.(ctx);
	TD.initSelectAll?.(ctx);
	TD.updateMapImages?.(ctx);
	initScripts.forEach(fn => fn(ctx));
}

function initButtons(ctx, data) {
	var cancelLink = location.href;
	var n = cancelLink.lastIndexOf("#");
	var ts = "&_=" + new Date().valueOf();
	// add timestamp to the end of query string
	if(n > 0) {
		cancelLink = cancelLink.substring(0, n) + ts + cancelLink.substring(n);
	} else {
		cancelLink += ts;
	}

	$("div.fs-layoutaction", ctx).empty()
	.append(
		$("<button>", { "class": "ui-button fs-action", type: "submit", value: "save" }).text(TD.Res["action.save"]),
		data.allowSaveNext ? $("<button>", { "class": "ui-button fs-action ui-icon-next", type: "button", value: "saveandnext" }).text(TD.Res["action.saveandnext"]) : "",
		$("<button>", { "class": "ui-button fs-action", type: "button", value: "refresh" }).text(TD.Res["action.refresh"]),
		$("<a>", { "class": "ui-button ", href: cancelLink }).text(TD.Res["action.cancel"]));
}

function initChangeTracking(ctx) {
	// ctx.is("form")
	function setBeforeUnload() {
		if(window.onbeforeunload == null) {
			window.onbeforeunload = function() {
				return TD.Res["form.confirmation_text"] || "Some data was changed. Proceed without saving?";
			};
		}
	}
	function resetBeforeUnload() {
		window.onbeforeunload = null;
	}

	// new record set some c_f_'s to 1, ns=1 indicates record is new and not refreshed
    if(!ctx.find("input[type=\"hidden\"][name=\"ns\"][value=\"1\"]:first").length &&
        ctx.find("input[type=\"hidden\"][name^=\"c_f_\"][value=\"1\"]:first").length)
		setBeforeUnload();
	ctx.on("change", setBeforeUnload).on("submit", resetBeforeUnload);
	// ...and wait a little until page load to handle button clicks
	addCallback(function() { ctx.find("div.fs-layoutaction").on("click", ".ui-button", resetBeforeUnload); });
}

function initEdit(ctx, data) {
	// set editable markers
	$.each(data.controls, function(n, c) { $("dl#" + n + "_label", ctx).toggleClass("ui-editable", !!c.ae); });
	// patch buttons
	if($("div.ui-gridlayout", ctx).hasClass("fs-edit")) {
		initButtons(ctx, data);
	}
	initEditableHover(ctx, data);
}

function appendLoadProgress(dl) {
	dl.addClass("td-ctrl-progress");
	$("<img class=\"td-ctrl-progress\" src=\"" + gRootURL + "/img/wait.gif\">")
	.css("background-color", dl.css("background-color"))
	.appendTo(dl.find(">dd>div.fs-attr").css("position", "relative"));
}

function startDoubleClickEdit(ctx, data, dl) {
	var id = /(f_\d+)_label/.exec(dl[0].id);
	// miss
	if(id == null) return;
	id = id[1];
	var ectl = $$(ctx, "e_" + id);
	if(!ectl.length) ectl = $("<input>", { name: "e_" + id, type: "hidden", value: "1" }).prependTo(ctx);
	else if(ectl.val() == "1") return;
	else ectl.val("1");

	var layout = $("div.ui-gridlayout", ctx);
	if(!layout.hasClass("fs-edit")) {
		layout.addClass("fs-edit");
		initButtons(ctx, data);
	}
	appendLoadProgress(dl);
	sendFormData(ctx, id, data, true);
}

function initEditableHover(ctx, data) {
	var btn = $("<a/>", { id: "td-startedit", href: "#", "class": "ui-icon-only" })
	.on("click", function(e) {
		var dl = $(this.parentNode.parentNode);
		if(dl.is(".ui-editable")) {
			btn.detach();
			e.preventDefault();
			startDoubleClickEdit(ctx, data, dl);
		}
		return false;
	});

	var dlSelector = "dl[id^=\"f_\"][id$=\"_label\"]:not(.td-ctrl-progress)";
	var ddSelector = ">dd:not(.fs-edit)";
	ctx = $(ctx);
	if(!touchEvents) {
		ctx.on("dblclick", dlSelector + ".ui-editable", function(e) {
			var dl = $(this);
			if(dl.find(ddSelector).length) {
				btn.detach();
				startDoubleClickEdit(ctx, data, dl);
				e.preventDefault();
			}
		}).on("mouseleave", dlSelector + ddSelector, function() {
			btn.hide();
		});
	}
	ctx.on("click mouseenter", dlSelector + ddSelector, function() {
		var p = $(this.parentNode);
		var editable = p.is(".ui-editable");
		btn.detach()
		.appendTo(this)
		.removeClass("ui-icon-pen ui-icon-lock")
		.addClass(editable ? "ui-icon-pen" : "ui-icon-lock")
		.css("background-color", (editable ? p.parent() : p).css("background-color"))
		.show()
		.position({
			my: "right top",
			at: "right top",
			of: this
		});
	});
}

function initForm(ctx, cb) {
	ctx = $(ctx);
	// add jquery support to some controls
	setTimeout(function() { initDynControls(ctx); if(cb) cb(ctx); }, 200);
}

function setFocus(ctx) {
	// ios does not support programmatical focus properly
	if(window.isIOS)
		return;
	// set focus to first visible element
	if(window.getSelection) {
		window.getSelection().removeAllRanges();
	} else if(document.selection) {
		document.selection.empty();
	}
	var i = $("select:visible:first,textarea:visible:first,input[type!=hidden][type!=submit][type!=reset][type!=image][type!=radio][type!=checkbox][type!=file]:visible:first", ctx);
	if(i.length > 0) {
		i[0].focus();
		if($.ensureVisible) {
			$.ensureVisible(i);
		}
	}
}

function initDeps(ctx, data) {
	if(data) {
		var deps = data.dependencies;
		for(var key in deps)
			setChangeCallback(ctx, key, data);
	}
}

function catchup(ctx, data, cb) {
	ctx = $(ctx);
	if(ctx.is("form")) {
		ctx[0].onsubmit = null;
		ctx.on("submit", function(e) {
			FS.Form.disableButtons(ctx);
			if(activeRequestCount > 0) {
				submitWasRequested = true;
				return false;
			}
			if(verifyRequired(ctx)) {
				FS.Form.disableButtons(ctx, true);
				e.stopPropagation();
				e.preventDefault();
				return false;
			}
		});
		if(data.preview)
			initEdit(ctx, data);
		initChangeTracking(ctx);
	}
	initDeps(ctx, data);
	// initForm called from here and from search init
	initForm(ctx, function (ctx) {
		// set focus only if not embedded
		if(ctx.closest("main#td-bodyframe").length)
			setFocus(ctx);
		if(cb) cb(ctx);
	});
}

function verifyRequired(ctx, suppressMessages) {
	ctx = $(ctx);
	var cells, layout = ctx.find("table.fs-layout");
	if(layout.length) {
		cells = layout.find("td.ui-required");
	}
	else {
		layout = ctx.find("div.ui-gridlayout");
		cells = layout.find("dl.ui-required > dd");
	}
	var err, errCount = 0, errHidden = {}, errHiddenCount = 0;
	cells.each(function() {
		var e = $(this);
		var m = /(f_\d+)_value$/.exec(e.attr("id"));
		if(m.length) {
			var els = $$(ctx, m[1]);
			if(!els.length) { // multiline append/prepend?
				els = $$(ctx, m[1] + "_h", m[1] + "_o");
			}
			if(els.length) {
				var value = [];
				els.each(function() {
					if(this.tagName != "INPUT" || (this.type != "checkbox" && this.type != "radio") || this.checked)
						value.push($(this).val());
				});
				err = e.find("div.ui-alert.ui-icon-error");

				value = value.join(" ").replace(/\s+$/, "");

				if(!value.length) {
					errCount++;
					(e.is("DD") ? e.parent() : e).addClass("ui-invalid");
					if(!suppressMessages) {
						var msg = TD.Res["form.error_value_missing"];
						if(e.is(":hidden")) {
							errHiddenCount++;
							errHidden[e[0].previousSibling.firstChild.textContent] = msg;
						} else {
							if(!err.length)
								err = $("<div class=\"ui-alert ui-icon-error ui-popup\"/>").appendTo(e);
							err.text(msg).show();
						}
					} else {
						err.remove();
					}
				}
				else {
					err.remove();
				}
			}
		}
	});
	if(errCount !== 0 && !suppressMessages) {
		var hdr = layout.parent().find(">header");
		err = hdr.find(">div.ui-alert");
		if(!err.length)
			err = $("<div>", { "class": "ui-alert ui-icon-error" }).appendTo(hdr);
		//
		err.empty()
			.append(document.createTextNode(String.format(TD.Res["form.invaliddata.1"], errCount)))
			.append("<br/>")
			.append(document.createTextNode(TD.Res["form.invaliddata.2"]));
		if(errHiddenCount) {
			var ul = $("<ul>").appendTo(err);
			for(var key in errHidden) {
				$("<li>").text(key + ": " + errHidden[key]).appendTo(ul);
			}
		}
	}
	return errCount;
}

const Ctrl = $.extend({}, td, {
	addInitControl,
	initForm,
	initDeps,
	setFocus,
	catchup
});

function getSpinner() {
	return $("<div>").css({ "position": "absolute", "left": "50%", "top": "50%", "margin-top": "-30px", "margin-left": "-30px" })
		.append($("<div/>", { "class": "ui-spinner" }).append($("<div/>").text(TD.Res["location.loading"])));
}

var supportsSVG = true;

function renderChart(id, url) {
	var ins = $("#" + id);
	var spinner = getSpinner();
	spinner.hide();
	ins.append(spinner);
	setTimeout(function () { spinner.show(); }, 300);

	function removeSpinner() { spinner.remove(); }

	if(supportsSVG) {
	    url += "&svg=1";
	    if(ins.hasClass("ui-responsive")) {
	        var w = Math.max((ins.width() | 0) - 8, 480);
	        url += "&w=-" + w;
		}
		$.ajax(url, {
			dataType: "xml",
			success: function(doc) {
				var svg = document.importNode(doc.documentElement, true);
				ins.append(svg);
			},
			error: function(xhr, errorStatus, errorThrown) {
				$("<p>").text(errorThrown || errorStatus).appendTo(ins);
			},
			complete: function() {
				removeSpinner();
			}
		});
	}
	else {
		ins.append($("<img>", { src: url + "&svg=0", onload: removeSpinner, onerror: removeSpinner }));
	}
}

export { Ctrl, renderChart };
